/*
• If only one lot is returned, no rows are shown

• Minimum lots to show one row on desktop is 3

• Minimum lots to show one row on tablet/mobile is 2

• Minimum lots to show two rows on desktop is 5

• Minimum lots to show two rows on tablet/mobile is 3

• Lot P1 should be the only lot that is repeated on desktop and tablet/mobile to fill in the last spot

• Minimum to show subsequent rows (3, 4, 5) etc should two one lot than the lots needed for the total. So row three which we would need 9 lots (three for row 1, three for row 2, and three for row 3) would need a minimum of 8 lots to show. P1 would fill in the P9 spot.

•• For row 4 which we would need 12 lots for (three for 1, three for row 2, three for row 3, and four row 4) would need 11 lots. P1 would fill in the P9 spot.
*/

import chunk from 'lodash/chunk';
import flatten from 'lodash/flatten';

export const blender = (itemIds: number[], promotedItemIds: number[], columns: number) => {
    if (promotedItemIds.length < columns) {
        return itemIds;
    }

    // Filter out any of the promoted items from the response
    const filteredItems = itemIds.filter((item) => !promotedItemIds.includes(item));

    // create a new array of the promoted items rather than editing the one from redux.
    const filledOutItemsIds = [...promotedItemIds];

    // ensure that we have a good, matching number of items for creating rows of 2 or 3
    if (columns === 3) {
        // if we have an extra pop off the last one
        if (promotedItemIds.length % 3 === 1) {
            filledOutItemsIds.pop();
        }
        // if we have one too few, just use the first one again to fill it out
        if (promotedItemIds.length % 3 === 2) {
            filledOutItemsIds.push(promotedItemIds[0]);
        }
    } else {
        // columns =2
        // if we have one too few, just use the first one again to fill it out
        if (promotedItemIds.length % 2 !== 0) {
            filledOutItemsIds.push(promotedItemIds[0]);
        }
    }

    // create chunks of itemIds that would equal 2 rows (columns count times 2)
    const chunkedItemIds = chunk(filteredItems, columns * 2) || [];

    // create chunks of promoted itemIds to make single rows (columns count)
    const chunkedPromotedItemIds = chunk(filledOutItemsIds, columns);

    // start out our new array of items with the first chunk of promoted itemIds
    const mixedArray = [chunkedPromotedItemIds.shift()];

    // now combine the rest of the chunks
    while (chunkedItemIds.length) {
        // add the next chunk of itemIds
        mixedArray.push(chunkedItemIds.shift());
        // if there are more chunks of promoted itemIds, add one
        if (chunkedPromotedItemIds.length) {
            mixedArray.push(chunkedPromotedItemIds.shift());
        }
    }

    // flatten the array into a single array of item ids
    return flatten(mixedArray);
};
